import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import reportWebVitals from './reportWebVitals';
import appTheme from './theme';
import App from './App';
import './index.css';

let appType = window.location.pathname.split('/')[2];
if (!['kolour_tw', 'kolour_yl'].includes(appType)) {
  appType = 'kolour_tw';
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={`/app/${appType}`}>
      <ThemeProvider theme={appTheme}>
        <App type={appType} />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
